import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteWorkEnvironmentSurvey } from '../../api/workEnvironmentQueries';
import { WorkEnvironmentSurveysByTeamIdQueryKey } from '../queries/useGetWorkEnvironmentSurveysByTeamIdQuery';
import { TeamSurveyOverviewQueryKey } from '../queries/useTeamSurveyOverviewQuery';

export const useDeleteWorkEnvironmentSurveyMutation = (teamId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (surveyId: number) => deleteWorkEnvironmentSurvey(surveyId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [WorkEnvironmentSurveysByTeamIdQueryKey, teamId],
      });
      queryClient.invalidateQueries({ queryKey: [TeamSurveyOverviewQueryKey, teamId] });
    },
  });
};
